export const updateLocalStorage = (key, value) => {
  localStorage.setItem(key, value)
  const event = new Event('storage')
  event.key = key
  event.newValue = value
  window.dispatchEvent(event)
}
